import React from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import { SectionModel } from "../../../models/components.model";
import { Address, DocumentUrl } from "../../../models/cartable.model";
import DetailInfoComponentThumbnail from "../../../components/detailInfo/detailInfoComponentThumbnail";

interface SchemaInfoModel {
  data?: Address;
  documentList: DocumentUrl[];
  withoutDoc: boolean;
}
const sections: SectionModel[] = [
  { dataKey: "postalCode", rowCol: 4, title: " کدپستی" },
  { dataKey: "inquityAddress", rowCol: 8, title: " آدرس" },
];

export default function GuarantorPlaceInfo(props: any) {
  return (
    <>
      <DivisionCmp
        child={
          <DetailInfoComponentThumbnail
            sections={sections}
            data={props}
            documentList={props.data}
            height={"20vh"}
            addressByInquiry={true}
            showFooter={false}
            headerHeight={"6vh"}
            align={"center"}
            // showDoc={withoutDoc}
          />
        }
        title={props.title ? props.title : "اطلاعات سکونتی"}
        marginTop={"10px"}
      />
    </>
  );
}
